import { FC } from 'react';
import { NudosButton } from '../../../../../../components/NudosComponents';
import { IReportingOptions } from '../../../../../../types/services';
import CheckArrowIcon from '../../../../../../assets/images/catalogue/CheckArrowIcon';

import './LogisticsServiceReportingOptions.scss';

interface ILogisticsServiceReportingOptions {
  loading: boolean;
  disabled: boolean;
  reportingOptionsList?: IReportingOptions[];
  selectedReportingOptions?: IReportingOptions[];
  handleSelectOptions: (option: IReportingOptions) => void;
  location: 'origin' | 'destination';
  handleContinue: () => void;
  sameCity: boolean;
}

const LogisticsServiceReportingOptions: FC<ILogisticsServiceReportingOptions> = ({
  loading,
  disabled,
  handleSelectOptions,
  location,
  handleContinue,
  sameCity,
  reportingOptionsList,
  selectedReportingOptions
}: ILogisticsServiceReportingOptions) => {
  return (
    <div id="logisticsServiceReportingOptions">
      {reportingOptionsList &&
        reportingOptionsList.length > 0 &&
        reportingOptionsList.map((item, index) => {
          const sameCityItem = (item?.name === 'Ciudad' || item?.name === 'Código Postal') && sameCity;
          return (
            <div
              className="itemList"
              key={`reporting-option-${item.id}-name-${item.name}-${index}-location-${location}`}
              style={{
                cursor: sameCity && (item?.name === 'Ciudad' || item?.name === 'Código Postal') ? 'not-allowed' : ''
              }}
              onClick={() => {
                if (!sameCityItem) {
                  handleSelectOptions(item);
                }
              }}
            >
              <div className="checkContainer">
                {sameCity && (item?.name === 'Ciudad' || item?.name === 'Código Postal') ? (
                  <div className="noValidItem" />
                ) : (
                  <>
                    {selectedReportingOptions?.find(option => option.id === item.id) ? (
                      <div className="selectItemReport">
                        <CheckArrowIcon stroke="white" style={{ transform: 'scale(0.9)' }} />
                      </div>
                    ) : (
                      <div className="noSelect" />
                    )}
                  </>
                )}
              </div>
              <div
                className="textContainer"
                style={{
                  color: sameCity && (item?.name === 'Ciudad' || item?.name === 'Código Postal') ? '#f0f0f0' : ''
                }}
              >
                {item.name}
              </div>
            </div>
          );
        })}

      <div className="containerButton">
        <NudosButton
          isButtonDisabled={loading || disabled}
          isButtonLoading={loading}
          customClassName="reportButton"
          buttonText="Continuar"
          customHeight="18px"
          customWidth="80px"
          handleClick={handleContinue}
        />
      </div>
    </div>
  );
};

export default LogisticsServiceReportingOptions;
